import z, { nativeEnum, object } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { AwardType } from '@occc-app/offerHelpers/types';
import {
  AwardPointsPerSchema,
  AwardPointsSchema,
  AwardVouchersWithExpirationDaysSchema,
} from '@occc/validation';

export const AwardPointsVariantSchema = object({
  awardType: z.literal(AwardType.AwardPoints),
  awardPoints: z.preprocess((data) => data ?? {}, AwardPointsSchema),
});

export const AwardVouchersVariantSchema = object({
  awardType: z.literal(AwardType.AwardVouchers),
  awardVouchers: z.preprocess((data) => data ?? {}, AwardVouchersWithExpirationDaysSchema),
});

export const AwardPointsPerVariantSchema = object({
  awardType: z.literal(AwardType.AwardPointsPer),
  awardPointsPer: z.preprocess((data) => data ?? {}, AwardPointsPerSchema),
});

// Offer create flow injects provider for AwardExternal, so no strict awardExternal payload validation.
export const AwardExternalVariantSchema = object({
  awardType: z.literal(AwardType.AwardExternal),
});

export const AwardNullableVariantSchema = object({
  awardType: z.literal(AwardType.AwardNullable),
});

export const DraftAwardTypeSchema = nativeEnum(AwardType, { required_error: IS_REQUIRED });
